// ---------------------------------------------------------------------------
// Minimal URL-based feature flag, requested explicitly so an in-progress
// feature (the calibration panel) can be shown to a specific tester by
// sharing a link, without shipping it to every visitor of the deployed app
// — there's no backend/auth to gate anything server-side (see
// project_evalhid_auth_featureflags.md for why that matters for anything
// that needs REAL restriction, which this isn't: it's a visibility toggle
// for an in-progress feature, not an access control).
// ---------------------------------------------------------------------------

/** `?calibrator` anywhere in the URL's query string shows the calibration button (TopBar.tsx). Takes `search` (defaults to the real `window.location.search`) so it's testable without a real URL. */
export function calibratorEnabled(search: string = window.location.search): boolean {
  return new URLSearchParams(search).has("calibrator");
}
